import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Text } from '@cowbell/ui';
import { useActor } from '../../../hooks/useActor';
import OrgProfile from './OrgProfile';

const OrgProfileResolver = () => {
  const history = useHistory();
  const { accountId: accountIdParam } = useParams<{ accountId: string }>();
  const actor = useActor();

  const accountId = actor.account.id || accountIdParam;

  React.useEffect(() => {
    if (accountIdParam === ':accountId') {
      history.replace(`/customer/manage/profile/${accountId}`);
    }
  }, [accountId, accountIdParam, history]);

  if (!accountId) {
    return (
      <Text ta="center" size="lg">
        An error occurred. Please contact Cowbell support for assistance
      </Text>
    );
  }

  return <OrgProfile accountId={accountId} />;
};

export default OrgProfileResolver;
